<template>
  <!-- TODO Improves -->
  <div v-if="firstLoad" class="m3 my3">
    <div v-if="!codesListing.value.length" class="p3 white-bg flex my3">
      <span class="flex flex-auto h5n semi-bold justify-center">{{ getReferencelabel("REFERRAL_TEXT") }}</span>
    </div>
    <div v-else v-for="(code, index) in codesListing.value" :key="index" class="py1 white-bg my3">
      <div class="col-12 flex flex-wrap py1">
        <div class="col-12 flex flex-column items-center">
          <span class="h4n bold m0 py2 center">{{ getReferencelabel("REFERRAL_TEXT_3") }}</span>
          <p class="h4n bold m0 py2 center">{{ descriptionMyCode(code)}}</p>
          <span class="h4n bold m0 py2 center">{{ getReferencelabel("REFERRAL_TEXT_2") }}{{ code.id }}</span>
        </div>
      </div>
    </div>
    <div v-if="showMoreButton" class="flex flex-wrap justify-center">
      <Button reference="SEE_MORE" class="col-8 md-col-6 lg-col-4 mb3" btn-color="inverted" :action="loadMoreCodes" />
    </div>
  </div>
</template>

<script>

import { onMounted, ref, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import Button from '@/components/elements/Button';
import Breadcrumb from '@/components/common/Breadcrumb';
import { getReferencelabel } from '@/mixins/utils';
import { format } from 'date-fns';


import { getCodes } from '@/mixins/requests';

export default {
  components: {
    Breadcrumb,
    Button
  },
  setup () {
    const store = useStore();
    const route = useRoute();
    const firstLoad = ref(false);
    const start = ref(0);
    const limit = ref(3);
    const codesCount = ref(0);
    const codesListing = reactive([]);
    const userUuid = ref(store.state.user.uuid);

    const showMoreButton = computed(() => codesCount.value > (start.value + limit.value));

    function descriptionMyCode(code) {
      const discount = code.discount ? `de ${code.discount}%` : '';
      const expiration = code.expires_at.split('T')[0];
      return `-75€ ${ getReferencelabel("REFERRAL_TEXT_4") } ${format(new Date(code.expires_at.split('T')[0]), 'dd/MM/yyyy')}`;
    }

    function isReferred (code) {
      if(code.referrer_uuid){
        return code.referrer_uuid == userUuid.value;
      }
      return code == false
    }

    async function loadMoreCodes () {
      start.value += limit.value;
      await syncCodes();
    }

    async function syncCodes () {
      store.commit('setLoading', true);
      const { count, items } = await getCodes(start.value, limit.value);

      codesCount.value = count;
      codesListing.value = [...codesListing.value || [], ...items || []];
      store.commit('setLoading', false);
    }

    onMounted(async () => {
      await syncCodes();
      firstLoad.value = true;
    });

    return { firstLoad, start, limit, codesCount, codesListing, userUuid, showMoreButton, loadMoreCodes, syncCodes, getReferencelabel, route, descriptionMyCode, isReferred };
  }
};
</script>

<style>

</style>

